<template>
  <div class="debt-installment-warranty-table">
    <b-table-simple
      bordered
      hover
      class="debt-installment-warranty-table__table tbody-hover"
      role="table"
      :aria-label="tableAriaLabel"
    >
      <b-thead>
        <b-tr role="row">
          <b-th class="debt-installment-warranty-table__header text-center tdDate" role="columnheader">Ngày</b-th>
          <b-th class="debt-installment-warranty-table__header text-center tdStore" role="columnheader">Cửa hàng</b-th>
          <b-th class="debt-installment-warranty-table__header text-center tdCustomer" role="columnheader">Khách hàng</b-th>
          <b-th class="debt-installment-warranty-table__header text-center tdProductName" role="columnheader">Dịch vụ trả góp</b-th>
          <b-th class="debt-installment-warranty-table__header text-center tdProductPrice" role="columnheader">Mã hợp đồng</b-th>
          <b-th class="debt-installment-warranty-table__header text-center tdProductPrice" role="columnheader">Tiền trả góp</b-th>
          <b-th class="debt-installment-warranty-table__header text-center tdTotalPayment" role="columnheader">Đã thanh toán</b-th>
          <b-th class="debt-installment-warranty-table__header text-center tdTotalPayment" role="columnheader">Còn lại</b-th>
          <b-th class="debt-installment-warranty-table__header text-center tdTotalAmount" role="columnheader">Tổng tiền bảo hành</b-th>
          <b-th class="debt-installment-warranty-table__header text-center" role="columnheader">Thao tác</b-th>
        </b-tr>
      </b-thead>
      <b-tbody v-for="warranty in data" :key="warranty.id">
        <b-tr v-for="(item, index) in warranty.payments" :key="index" role="row">
          <b-td
            :rowspan="warranty.payments.length + 1"
            class="debt-installment-warranty-table__cell tdDate"
            v-show="isShowRow(warranty.payments, item)"
            role="cell"
          >
            <div>{{ formatDate(warranty.createdAt) }}</div>
            <div>
              <router-link
                :to="getDocLink(warranty)"
                target="_blank"
                class="debt-installment-warranty-table__doc-link"
              >
                {{ getDocDisplay(warranty) }}
              </router-link>
            </div>
          </b-td>
          <b-td
            :rowspan="warranty.payments.length + 1"
            class="debt-installment-warranty-table__cell text-left tdStore"
            v-show="isShowRow(warranty.payments, item)"
            role="cell"
          >
            {{ warranty.storeName }}
          </b-td>
          <b-td
            :rowspan="warranty.payments.length + 1"
            class="debt-installment-warranty-table__cell text-left tdCenter tdCustomer"
            v-show="isShowRow(warranty.payments, item)"
            role="cell"
          >
            <div class="debt-installment-warranty-table__customer-info">
              <b>{{ warranty.customerName }}</b>
              <p>{{ warranty.customerMobile }}</p>
            </div>
          </b-td>
          <b-td class="debt-installment-warranty-table__cell text-left tdProductName" role="cell">
            <b>{{ item.paymentName }}</b>
          </b-td>
          <b-td class="debt-installment-warranty-table__cell text-right tdProductPrice" role="cell">
            {{ item.paymentCode }}
          </b-td>
          <b-td class="debt-installment-warranty-table__cell text-right tdProductPrice" role="cell">
            {{ formatCurrency(item.paymentAmount) }}
          </b-td>
          <b-td
            :rowspan="warranty.payments.length + 1"
            class="debt-installment-warranty-table__cell text-right tdCenter"
            v-show="isShowRow(warranty.payments, item)"
            role="cell"
          >
            {{ formatCurrency(warranty.sumAmountTransactions) }}
          </b-td>
          <b-td
            :rowspan="warranty.payments.length + 1"
            class="debt-installment-warranty-table__cell text-right tdCenter"
            v-show="isShowRow(warranty.payments, item)"
            role="cell"
          >
            {{ formatCurrency(warranty.sumRemainTransaction) }}
          </b-td>
          <b-td
            :rowspan="warranty.payments.length + 1"
            class="debt-installment-warranty-table__cell text-right tdCenter"
            v-show="isShowRow(warranty.payments, item)"
            role="cell"
          >
            {{ formatCurrency(warranty.totalAmount) }}
          </b-td>
          <b-td class="debt-installment-warranty-table__cell text-center" role="cell">
            <b-dropdown
              v-if="warranty.sumRemainTransaction > 0"
              size="sm"
              right
              no-caret
              class="debt-installment-warranty-table__action-dropdown"
            >
              <template slot="button-content">
                <i class="flaticon2-settings debt-installment-warranty-table__action-icon"></i>
              </template>
              <b-dropdown-item @click="$emit('cash-payment', { warranty, item })" class="debt-installment-warranty-table__action-item">
                <span class="debt-installment-warranty-table__action-text">
                  <i class="far fa-money-bill-alt"></i>
                  &nbsp; Thanh toán bằng tiền mặt
                </span>
              </b-dropdown-item>
              <b-dropdown-item class="debt-installment-warranty-table__action-item">
                <router-link :to="getBankPaymentRoute(warranty, item)" class="debt-installment-warranty-table__action-link">
                  <span class="debt-installment-warranty-table__action-text">
                    <i class="fas fa-money-check-alt"></i>
                    &nbsp; Thanh toán bằng CK ngân hàng
                  </span>
                </router-link>
              </b-dropdown-item>
            </b-dropdown>
          </b-td>
        </b-tr>
      </b-tbody>
      <b-tfoot>
        <tr role="row">
          <td colspan="5" class="debt-installment-warranty-table__summary-label text-right" role="cell"><b>Tổng</b></td>
          <td class="debt-installment-warranty-table__summary-value text-right" role="cell"><b>{{ totals.totalPaymentAmount }}</b></td>
          <td class="debt-installment-warranty-table__summary-value text-right" role="cell"><b>{{ totals.totalPaidAmount }}</b></td>
          <td class="debt-installment-warranty-table__summary-value text-right" role="cell"><b>{{ totals.totalRemainingAmount }}</b></td>
          <td class="debt-installment-warranty-table__summary-value text-right" role="cell"><b>{{ totals.totalBillAmount }}</b></td>
          <td role="cell"></td>
        </tr>
      </b-tfoot>
    </b-table-simple>
    <vcl-table v-if="isLoading" :speed="5" :animate="true" :columns="11" />
  </div>
</template>

<script>
import { convertPrice } from '@/utils/common';
import { formatDate as formatDateUtil } from '@/utils/date';
import _ from 'lodash';
import { VclTable } from 'vue-content-loading';

export default {
  name: 'DebtInstallmentWarrantyTable',
  components: { VclTable },
  props: {
    data: { type: Array, default: () => [], validator: (d) => Array.isArray(d) },
    isLoading: { type: Boolean, default: false },
    totals: {
      type: Object,
      default: () => ({
        totalPaymentAmount: '0',
        totalPaidAmount: '0',
        totalRemainingAmount: '0',
        totalBillAmount: '0',
      }),
    },
  },
  computed: {
    tableAriaLabel() {
      return 'Bảng dữ liệu công nợ trả góp bảo hành';
    },
  },
  methods: {
    isShowRow(payments, currentItem) {
      return _.findIndex(payments, ['id', currentItem.id]) === 0;
    },
    formatCurrency(amount) {
      return convertPrice(amount);
    },
    formatDate(dateString) {
      return formatDateUtil(dateString);
    },
    getDocDisplay(warranty) {
      return warranty.id
    },
    getDocLink(warranty) {
      return {
        name: 'warranty-dispatch-info',
        query: { id: warranty.id },
      };
    },
    getBankPaymentRoute(warranty, item) {
      return {
        name: 'transaction',
        params: {
          mainModelProp: {
            contactType: '3',
            reconciliationDocType: '8',
            reconciliationDocId: String(warranty.id),
            type: '3',
            contactId: item.paymentRefId,
            contactName: item.paymentName,
            amount: item.paymentAmount,
            note: this.generatePaymentNote(warranty, item),
          },
          mode: 'bank',
          action: 'add',
          id: 'new',
        },
      };
    },
    generatePaymentNote(warranty, item) {
      let note = `Nhận thanh toán từ trả góp bảo hành\n`;
      note += `ID BH: ${warranty.id}\n`;
      note += `Mã phiếu BH: ${warranty.code}\n`;
      note += `Dịch vụ: ${item.paymentName}\n`;
      note += `Mã hợp đồng: ${item.paymentCode || ''}`;
      return note;
    },
  },
};
</script>

<style lang="scss" scoped>
.debt-installment-warranty-table {
  &__table .table th,
  &__table .table td {
    vertical-align: middle;
  }
  &__header {
    font-weight: 600;
    color: #181c32;
  }
  &__customer-info p {
    margin-bottom: 0;
  }
  &__amount-paid,
  &__amount-remaining,
  &__amount-total {
    color: #3c763d;
    font-weight: 700;
    width: 10%;
  }
  &__actions {
    width: 5%;
  }
  &__action-icon {
    font-size: 1rem !important;
  }
  &__action-text {
    color: #3f4254;
    font-size: 12px;
  }
  &__action-link {
    color: #3f4254;
    text-decoration: none;
    &:hover {
      color: #3f4254;
      text-decoration: none;
    }
  }
  &__summary-label,
  &__summary-value {
    font-weight: bold;
  }
}
</style>
